export const UI_DRAWER_OPEN_SELECT_POSSIBLE_FREIGHT_PRICE =
  'UI_DRAWER_OPEN_SELECT_POSSIBLE_FREIGHT_PRICE'
export const UI_DRAWER_CLOSE_SELECT_POSSIBLE_FREIGHT_PRICE =
  'UI_DRAWER_CLOSE_SELECT_POSSIBLE_FREIGHT_PRICE'

export const openSelectPossibleFreightPriceDrawer = (load) => ({
  type: UI_DRAWER_OPEN_SELECT_POSSIBLE_FREIGHT_PRICE,
  payload: { load },
})

export const closeSelectPossibleFreightPriceDrawer = () => ({
  type: UI_DRAWER_CLOSE_SELECT_POSSIBLE_FREIGHT_PRICE,
})

const initialState = {
  selectPossibleFreightPrice: {
    open: false,
    load: null,
  },
}

export default function uiDrawers(state = initialState, action) {
  switch (action.type) {
    case UI_DRAWER_OPEN_SELECT_POSSIBLE_FREIGHT_PRICE:
      return {
        ...state,
        selectPossibleFreightPrice: {
          open: true,
          load: action?.payload?.load || null,
        },
      }
    case UI_DRAWER_CLOSE_SELECT_POSSIBLE_FREIGHT_PRICE:
      return {
        ...state,
        selectPossibleFreightPrice: {
          open: false,
          load: null,
        },
      }
    default:
      return state
  }
}

